import React, { useState, useEffect } from "react";
import { Container, Form, Alert} from 'react-bootstrap';
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';

import {Sida,Rubrik,Stycke,ContentWrapper,Button} from "../ContentStyles";

const Info = () => {
  const [resultText, setResultText] = useState(":)");
  const [resultVariant, setResultVariant] = useState("success");
  const [resultVisible, setResultVisible] = useState(false);
  const [spinnerHidden, setSpinnerHidden] = useState(true);    

  async function handleSubmit(e) {
    e.preventDefault();
    //setSaving(true);
    setResultText("");
    setResultVisible(false);

    const RequestNewPasswordForm = document.getElementById('RequestNewPasswordForm');
    const formData = new FormData(RequestNewPasswordForm);
    const formDataObj = Object.fromEntries(formData.entries());

    let {resultVariant, resultVisible, resultText, jsondata} = await CallAPI('/api/requestnewpassword', 'POST', JSON.stringify(formDataObj));
    console.log(resultText);
    setResultVariant(resultVariant);   
    setResultText(resultText);
    setResultVisible(resultVisible);

    //Refresh();
    //setSaving(false);
  }  
    
  return (
    <ContentWrapper>
      <Sida>
        <Rubrik>Begär nytt lösenord</Rubrik>
        <Stycke>

          <Form id="RequestNewPasswordForm" onSubmit={handleSubmit}>

            <Form.Group className="mb-3">
              <Form.Label className="FormHeaderText">Email</Form.Label>
              <Form.Control autoFocus type="email" name="username" />
            </Form.Group>  

            <Form.Group className="mb-3"  hidden={spinnerHidden}>
                <SpinnerX  />
            </Form.Group>                                      
                
            <Form.Group className="mb-3"  hidden={!resultVisible}>
                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
            </Form.Group>        

            <Form.Group className="mb-3">
                <Button className="QmeButton" variant="primary" type="submit">Skicka</Button>
            </Form.Group>   

          </Form> 
        </Stycke>
      </Sida>
    </ContentWrapper>
  );
};

export default Info;